import { all } from "redux-saga/effects";
import shootsagas from "./shootsagas";
import videoshotsagas from "./shoot/videoshotsagas";
import photoshotsagas from "./shoot/photoshotsagas";
import interviewees from "./shoot/intervieweessagas";
import services from "./shoot/servicessagas";
import languages from './shoot/langaugessagas'
import participants from './shoot/participantssagas'
import _ from "lodash";

export default function* rootSaga() {
  yield all([
    ..._.map(shootsagas, sagas => {
      return sagas();
    }),
    ..._.map(photoshotsagas, sagas => {
      return sagas();
    }),
    ..._.map(videoshotsagas, sagas => {
      return sagas();
    }),
    ..._.map(interviewees, sagas => {
      return sagas();
    }),
    ..._.map(services, sagas => {
      return sagas();
    }),
    ..._.map(languages, sagas => {
      return sagas();
    }),
    ..._.map(participants, sagas => {
      return sagas();
    }),
  ]);
}
